import { render, staticRenderFns } from "./CompGamificationMainMenu.vue?vue&type=template&id=1cbba9fb&scoped=true"
var script = {}
import style0 from "./CompGamificationMainMenu.vue?vue&type=style&index=0&id=1cbba9fb&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbba9fb",
  null
  
)

export default component.exports